// extracted by mini-css-extract-plugin
export default {"container":"CallCenterKnowledgeBase_container__kP3xp"};